import _Switch from "@alifd/next/es/switch";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import * as React from 'react';
import './index.less';
var BoolSetter = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(BoolSetter, _React$PureComponent);
  function BoolSetter() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  var _proto = BoolSetter.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      _onChange = _this$props.onChange,
      value = _this$props.value;
    return /*#__PURE__*/React.createElement(_Switch, {
      className: "switch-style",
      checked: value,
      size: "small",
      onChange: function onChange(val) {
        return _onChange(val);
      }
    });
  };
  return BoolSetter;
}(React.PureComponent);
BoolSetter.displayName = 'BoolSetter';
export { BoolSetter as default };